import { supabase } from "@/integrations/supabase/client";

export interface Progresso {
  empresa_id: string;
  tem_conexao: boolean;
  tem_status_personalizado: boolean;
  tem_equipe: boolean;
  tem_primeira_conversa: boolean;
  tem_venda: boolean;
  concluido: boolean;
  pulado: boolean;
}

/**
 * O progresso vem do estado REAL, nao de um "passo atual" guardado.
 *
 * Guardar o passo mentiria assim que alguem removesse a conexao, ou fizesse o
 * passo por outro caminho. A pergunta certa e sempre "isto ja esta feito?".
 */
export async function buscarProgresso(): Promise<Progresso | null> {
  const { data, error } = await supabase.rpc("progresso_onboarding");
  if (error) throw error;
  return ((data as Progresso[]) ?? [])[0] ?? null;
}

export async function encerrarOnboarding(pulou = false): Promise<void> {
  const { error } = await supabase.rpc("encerrar_onboarding", { p_pulou: pulou });
  if (error) throw error;
}
